import * as analytics from 'analytics/Analytics';
import {WORKLISTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import runModal from 'ui-library/runModal';
import SelectWorklistModal from 'worklists/SelectWorklistModal';
import {
  ValidateWorklistItems,
  Worklist,
  WORKLIST_FILL_LOCATION,
  WorklistType,
} from 'worklists/WorklistConstants';

/**
 * Select a worklist and get its item ids and metadata.
 *
 * Returns a copy of the selected worklist, with items that are archived or that the user
 * cannot access removed from worklist.itemdIds.
 * The archived and inaccessible item ids can still be retrieved from
 * worklist.archivedItemIds and worklist.inaccessibleItemIds, if necessary.
 */
export default async function fillFromWorklist(
  worklistTypes: Array<WorklistType>,
  fillLocation: WORKLIST_FILL_LOCATION,
  validateItems?: ValidateWorklistItems
): Promise<Worklist | null> {
  const worklist = await runModal(SelectWorklistModal, {worklistTypes, validateItems});

  if (worklist) {
    analytics.deprecatedTrackEvent(WORKLISTS_ANALYTICS_ACTIONS.FILLED_FROM_WORKLIST, {
      fill_location: fillLocation,
      worklist_type: worklist.itemType,
      num_items: worklist.itemIds.length,
    });
    return worklist;
  } else {
    return null;
  }
}
